// Dates and times in the company's time zone (companies.timezone, migration
// 109), which /api/auth/me returns as user.timezone and /api/portal/me as
// customer.timezone. Every "today" a page sends and every time it shows is
// read in that zone, not the phone's and not UTC.

// The zone every company had before 109, and the column's default. Used only
// when no zone has arrived yet (a profile cached before 109).
export const DEFAULT_TIMEZONE = 'America/Chicago';

export const zoneOrDefault = (timezone) => timezone || DEFAULT_TIMEZONE;

// Today's calendar day in the zone, as 'YYYY-MM-DD', for date inputs and the
// dates a page sends. new Date().toISOString().split('T')[0] is the UTC day,
// which in Chicago after 7 PM CDT is already tomorrow. en-CA formats as
// YYYY-MM-DD.
export const companyToday = (timezone, now = new Date()) =>
  now.toLocaleDateString('en-CA', { timeZone: zoneOrDefault(timezone) });

// toLocale*String options with the zone set, for a formatter that shows an
// instant: toLocaleString('en-US', inZone(timezone, { month: 'short' })).
export const inZone = (timezone, options = {}) => ({ ...options, timeZone: zoneOrDefault(timezone) });

// The browser's zone, sent once at signup. The server keeps it when it is on
// the list and uses the default otherwise, so an empty answer is harmless.
export const browserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch (e) {
    return '';
  }
};

// An instant as the zone's wall clock, 'YYYY-MM-DDTHH:mm', for a
// datetime-local input (the season Remind schedule picker). The server reads
// the same string back in the same zone.
export const zonedInputValue = (instant, timezone) => {
  const parts = {};
  new Intl.DateTimeFormat('en-US', inZone(timezone, {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  })).formatToParts(new Date(instant)).forEach((p) => { parts[p.type] = p.value; });
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};
